import React from 'react';

export const TimeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M12 1.75A10.25 10.25 0 1 0 22.25 12 10.26 10.26 0 0 0 12 1.75zm0 18.5A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25zm.75-12.5h-3v1.5h1.5v4.5h1.5V7.75zm4.5 5.25h-3v1.5h4.5v-1.5z" />
  </svg>
);

export const FromIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="#4caf50" // 起点绿色
  >
    <path d="M12 2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 10.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5z" />
    <path d="M12 22a10.5 10.5 0 0 1-7.5-3.1 1 1 0 0 1 1.4-1.4A8.5 8.5 0 0 0 12 20a8.5 8.5 0 0 0 6.1-2.5 1 1 0 0 1 1.4 1.4A10.5 10.5 0 0 1 12 22z" />
  </svg>
);

export const ToIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="#f44336" // 终点红色
  >
    <path d="M12 2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 10.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5z" />
    <path d="M12 24a1 1 0 0 1-1-1v-4a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1z" />
  </svg>
);
